module.exports = __webpack_public_path__ + "img/vans.1713bceb.jpg";